import React, { createContext, useEffect, useState } from "react";

const ScrollContext = createContext();

export const ScrollProvider = ({ children }) => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    // Restore scroll position after a delay to avoid conflicts with Gatsby navigation
    setTimeout(() => {
      window.scrollTo(0, scrollY);
    }, 50);
  }, []);

  return (
    <ScrollContext.Provider value={{ scrollY, setScrollY }}>
      {children}
    </ScrollContext.Provider>
  );
};

export default ScrollContext;
